import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Badge } from 'rsuite';
import { icons } from '@shared/static/icons';
import { isMenuItemDisabled } from '@utils/userMenu';

export default function SidebarLink({ item }) {
  const location = useLocation();
  const { isUnverified, isFrozen } = useSelector((state) => state.user);
  const { t } = useTranslation();

  const isDisabled = isMenuItemDisabled(item, isUnverified, isFrozen);

  return (
    <Link
      to={item.path}
      className={`sidebar__menu-item ${location.pathname === item.path ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
    >
      {isDisabled ? icons.lock : icons[item.icon]}
      <span>{t(item.text)}</span>
      {/* {item.path === '/support' && !isDisabled && (
        <div className="custom-badge-wrap">
          <Badge className="custom-badge" content={2} />
        </div>
      )} */}
    </Link>
  );
}
